"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[538,4188,107,6717],{

/***/ 51469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sx": function() { return /* binding */ useBreakpointValue; }
/* harmony export */ });
/* unused harmony exports Hide, Show, useBreakpoint, useColorModePreference, useMediaQuery, usePrefersReducedMotion, useQuery */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83904);
/* harmony import */ var _chakra_ui_react_env__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18229);
/* harmony import */ var _chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54302);
// ../../../react-shim.js


// src/media-query.tsx

var getBreakpoint = (theme, value) => {
  var _a;
  return ((_a = theme == null ? void 0 : theme.breakpoints) == null ? void 0 : _a[value]) ?? value;
};
function useQuery(props) {
  const { breakpoint = "", below, above } = props;
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  const bpBelow = getBreakpoint(theme, below);
  const bpAbove = getBreakpoint(theme, above);
  let query = breakpoint;
  if (bpBelow) {
    query = `(max-width: ${bpBelow})`;
  } else if (bpAbove) {
    query = `(min-width: ${bpAbove})`;
  }
  return query;
}

// src/use-media-query.ts


function useMediaQuery(query, options = {}) {
  const { ssr = true, fallback } = options;
  const env = (0,_chakra_ui_react_env__WEBPACK_IMPORTED_MODULE_2__/* .useEnvironment */ .O)();
  const queries = Array.isArray(query) ? query : [query];
  let fallbackValues = Array.isArray(fallback) ? fallback : [fallback];
  fallbackValues = fallbackValues.filter((v) => v != null);
  const [value, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => {
    return queries.map((query2, index) => ({
      media: query2,
      matches: ssr ? !!fallbackValues[index] : env.window.matchMedia(query2).matches
    }));
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setValue(queries.map((query2) => ({
      media: query2,
      matches: env.window.matchMedia(query2).matches
    })));
    const mql = queries.map((query2) => env.window.matchMedia(query2));
    const handler = (evt) => {
      setValue((prev) => {
        return prev.slice().map((item) => {
          if (item.media === evt.media)
            return { ...item, matches: evt.matches };
          return item;
        });
      });
    };
    mql.forEach((mql2) => {
      if (typeof mql2.addListener === "function") {
        mql2.addListener(handler);
      } else {
        mql2.addEventListener("change", handler);
      }
    });
    return () => {
      mql.forEach((mql2) => {
        if (typeof mql2.removeListener === "function") {
          mql2.removeListener(handler);
        } else {
          mql2.removeEventListener("change", handler);
        }
      });
    };
  }, [env.window]);
  return value.map((item) => item.matches);
}

// src/media-query.hook.ts
function usePrefersReducedMotion(options) {
  const [prefersReducedMotion] = useMediaQuery("(prefers-reduced-motion: reduce)", options);
  return prefersReducedMotion;
}
function useColorModePreference(options) {
  const [isLight, isDark] = useMediaQuery(["(prefers-color-scheme: light)", "(prefers-color-scheme: dark)"], options);
  if (isLight)
    return "light";
  if (isDark)
    return "dark";
  return void 0;
}

// src/use-breakpoint.ts


// ../../utilities/shared-utils/src/index.ts
function isObject(value) {
  const type = typeof value;
  return value != null && (type === "object" || type === "function") && !Array.isArray(value);
}

// src/use-breakpoint.ts
function useBreakpoint(arg) {
  var _a;
  const opts = isObject(arg) ? arg : { fallback: arg ?? "base" };
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  const breakpoints = theme.__breakpoints.details.map(({ minMaxQuery, breakpoint }) => ({
    breakpoint,
    query: minMaxQuery.replace("@media screen and ", "")
  }));
  const fallback = breakpoints.map((bp) => bp.breakpoint === opts.fallback);
  const values = useMediaQuery(breakpoints.map((bp) => bp.query), { fallback, ssr: opts.ssr });
  const index = values.findIndex((value) => value == true);
  return ((_a = breakpoints[index]) == null ? void 0 : _a.breakpoint) ?? opts.fallback;
}

// src/use-breakpoint-value.ts



// src/media-query.utils.ts

function getClosestValue(values, breakpoint, breakpoints = _chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__/* .breakpoints */ .AV) {
  let index = Object.keys(values).indexOf(breakpoint);
  if (index !== -1) {
    return values[breakpoint];
  }
  let stopIndex = breakpoints.indexOf(breakpoint);
  while (stopIndex >= 0) {
    const key = breakpoints[stopIndex];
    if (values.hasOwnProperty(key)) {
      index = stopIndex;
      break;
    }
    stopIndex -= 1;
  }
  if (index !== -1) {
    const key = breakpoints[index];
    return values[key];
  }
  return void 0;
}

// src/use-breakpoint-value.ts
function useBreakpointValue(values, arg) {
  var _a;
  const opts = isObject(arg) ? arg : { fallback: arg ?? "base" };
  const breakpoint = useBreakpoint(opts);
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  if (!breakpoint)
    return;
  const breakpoints = Array.from(((_a = theme.__breakpoints) == null ? void 0 : _a.keys) || []);
  const obj = Array.isArray(values) ? Object.fromEntries(Object.entries((0,_chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__/* .arrayToObjectNotation */ .Yq)(values, breakpoints)).map(([key, value]) => [key, value])) : values;
  return getClosestValue(obj, breakpoint, breakpoints);
}

// src/visibility.tsx
function Visibility(props) {
  const { breakpoint, hide, children, ssr } = props;
  const [show] = useMediaQuery(breakpoint, { ssr });
  const isVisible = hide ? !show : show;
  const rendered = isVisible ? children : null;
  return rendered;
}

// src/show.tsx
function Show(props) {
  const { children, ssr } = props;
  const query = useQuery(props);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Visibility, {
    breakpoint: query,
    ssr
  }, children);
}
Show.displayName = "Show";

// src/hide.tsx
function Hide(props) {
  const { children, ssr } = props;
  const query = useQuery(props);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Visibility, {
    breakpoint: query,
    hide: true,
    ssr
  }, children);
}
Hide.displayName = "Hide";



/***/ }),

/***/ 83935:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_uikit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82106);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51469);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48641);
/* harmony import */ var src_utils_gtm__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29590);
/* harmony import */ var src_utils_gtm__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28173);
/* harmony import */ var _common_Carousel__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71054);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(56917);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


const _excluded = ["title", "href", "action", "alt", "offers", "target", "numPerView", "w", "bgColor", "listId", "listName", "trackView"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










const HomeOffersList = _ref => {
  let {
    title,
    href,
    action,
    alt,
    offers,
    target,
    numPerView,
    w,
    bgColor,
    listId = 'home_nlt_offers',
    listName = 'Home — Offerte noleggio a lungo termine',
    trackView = true
  } = _ref,
      others = (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  const isMobile = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .useBreakpointValue */ .Sx)({
    base: true,
    md: false
  });
  const listItems = offers.map((offer, index) => (0,src_utils_gtm__WEBPACK_IMPORTED_MODULE_5__/* .rentOfferToProductItem */ .ck)(offer, {
    index
  }));
  (0,src_utils_gtm__WEBPACK_IMPORTED_MODULE_6__/* .useViewItemList */ .A)({
    items: listItems,
    listId,
    listName,
    enabled: trackView
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
    bgColor: bgColor || 'white',
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Container */ .W2, _objectSpread(_objectSpread({
      as: _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu,
      maxW: w || '8xl',
      pt: 10
    }, others), {}, {
      id: "offers-list-rent",
      px: "0",
      children: [title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        title: title,
        action: action,
        href: href,
        alt: alt,
        target: target
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_common_Carousel__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        withCustomNavigation: !isMobile,
        breakpoints: {
          320: {
            slidesPerView: 1.3,
            spaceBetween: 18,
            centeredSlides: true
          },
          480: {
            slidesPerView: 2,
            spaceBetween: 30
          },
          640: {
            slidesPerView: numPerView ? Math.ceil(numPerView / 2) : 3,
            spaceBetween: 30
          },
          1280: {
            slidesPerView: numPerView || 4,
            spaceBetween: 30
          }
        },
        withScrollbar: true,
        className: isMobile ? 'has-partial-slide' : null,
        children: offers.map((offer, index) => {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_common_Carousel__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Item */ .Z.Item, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(___WEBPACK_IMPORTED_MODULE_10__["default"], {
              item: offer,
              index: index,
              listId: listId,
              listName: listName
            })
          }, offer.code);
        })
      })]
    }))
  });
};

/* harmony default export */ __webpack_exports__["default"] = (HomeOffersList);

/***/ }),

/***/ 71054:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export CarouselItem */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62852);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85278);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53918);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13390);
/* harmony import */ var swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68770);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var swiper_css_grid__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2416);
/* harmony import */ var swiper_css_grid__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(swiper_css_grid__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);












swiper__WEBPACK_IMPORTED_MODULE_1__/* ["default"].use */ .ZP.use([swiper__WEBPACK_IMPORTED_MODULE_1__/* .Scrollbar */ .LW, swiper__WEBPACK_IMPORTED_MODULE_1__/* .Pagination */ .tl, swiper__WEBPACK_IMPORTED_MODULE_1__/* .Navigation */ .W_, swiper__WEBPACK_IMPORTED_MODULE_1__/* .Grid */ .rj]);
const Wrapper = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].span.withConfig({
  componentId: "sc-1vzw1za-0"
})(["position:relative;display:", ";.swiper-grid-column{height:100%;}"], props => props.withCustomNavigation ? 'block' : 'inline');
/*
  workaround
  @see https://github.com/nolimits4web/swiper/issues/4413
  @see https://github.com/nolimits4web/swiper/issues/4084
*/

const Item = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.Fragment, {
    children: children
  });
};

const CarouselItem = _ref2 => {
  let {
    children
  } = _ref2;
  return /*#__PURE__*/_jsx(SwiperSlide, {
    children: children
  });
};

const Carousel = _ref3 => {
  let {
    children,
    withScrollbar,
    withNavigation,
    withCustomNavigation,
    withPagination,
    slidesPerView,
    spaceBetween,
    className,
    breakpoints,
    grid
  } = _ref3;
  const {
    0: uniqueId,
    1: setUniqueId
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setUniqueId(`${Math.random()}`.substring(2, 15));
  }, []);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(Wrapper, {
    className: className || '',
    withCustomNavigation: withCustomNavigation,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .Swiper */ .tq, {
      navigation: withCustomNavigation ? {
        nextEl: `.carousel-custom-next--${uniqueId}`,
        prevEl: `.carousel-custom-prev--${uniqueId}`
      } : withNavigation || false,
      pagination: withPagination ? {
        clickable: true
      } : false,
      scrollbar: withScrollbar ? {
        draggable: true,
        hide: false
      } : false,
      slidesPerView: slidesPerView || 'auto',
      spaceBetween: spaceBetween || 1,
      breakpoints: breakpoints,
      grid: grid,
      loopFillGroupWithBlank: true,
      children: [withCustomNavigation && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
          className: `carousel-custom-next carousel-custom-next--${uniqueId}`
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
          className: `carousel-custom-prev carousel-custom-prev--${uniqueId}`
        })]
      }), react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, child => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .SwiperSlide */ .o5, {
        children: child
      }))]
    })
  });
};

Carousel.Item = Item;
/* harmony default export */ __webpack_exports__["Z"] = (Carousel);

/***/ }),

/***/ 36717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);


const ArrowRightIcon = () => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
      fill: "#262626",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M9.603 3.75c.207 0 .374.168.374.374v7.36l2.718-2.69c.138-.137.36-.137.498 0l.58.58c.138.138.138.36 0 .498l-4.336 4.301c-.137.138-.36.138-.498 0l-4.336-4.3c-.137-.138-.137-.36 0-.499l.58-.58c.138-.137.36-.137.498 0l2.718 2.69v-7.36c0-.18.129-.331.3-.366l.075-.008z",
        transform: "translate(-1377 -1392) translate(45 1377) translate(1146 14) translate(186 1) rotate(-90 9.188 9.013)"
      })
    })
  })
});

/* harmony default export */ __webpack_exports__["Z"] = (ArrowRightIcon);

/***/ }),

/***/ 20316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48641);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




const SimpleLink = _ref => {
  let {
    action,
    href,
    title,
    target
  } = _ref;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .rU, {
    color: "primaryGreen.800",
    title: title,
    target: target || '_self',
    fontFamily: "Montserrat-Medium, sans-serif",
    fontSize: "1rem",
    letterSpacing: "0.3px",
    lineHeight: "22.8px",
    _hover: {
      textDecoration: 'none'
    },
    href: href,
    children: action
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SimpleLink);

/***/ }),

/***/ 89149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48641);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


const _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





const H3 = _ref => {
  let {
    children
  } = _ref,
      others = (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, _objectSpread(_objectSpread({
    as: "h3",
    marginBottom: "xxl4",
    fontFamily: "Montserrat-SemiBold",
    fontSize: "1.75rem",
    lineHeight: "2.275rem"
  }, others), {}, {
    color: "baseDark",
    children: children
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (H3);

/***/ }),

/***/ 82106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53918);
/* harmony import */ var src_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89149);
/* harmony import */ var src_uikit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20316);
/* harmony import */ var src_styles_styled_components_Texts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2732);
/* harmony import */ var src_icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36717);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51469);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);









const Action = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
  componentId: "sc-1cdvsk2-0"
})(["text-align:center;& svg{display:inline;margin-bottom:-3px;}& a{", "}"], src_styles_styled_components_Texts__WEBPACK_IMPORTED_MODULE_3__/* .TextStyles.interactiveLinksSDark500Sx */ .k.interactiveLinksSDark500Sx);
const ActionFloat = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].span.withConfig({
  componentId: "sc-1cdvsk2-1"
})(["float:right;& svg{display:inline;margin-bottom:-3px;}& a{", "}"], src_styles_styled_components_Texts__WEBPACK_IMPORTED_MODULE_3__/* .TextStyles.interactiveLinksSDark500Sx */ .k.interactiveLinksSDark500Sx);

const SectionTitle = _ref => {
  let {
    title,
    action,
    alt,
    href,
    target,
    icon
  } = _ref;
  const isMobile = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .useBreakpointValue */ .Sx)({
    base: true,
    md: false
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(src_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    textAlign: isMobile ? 'center' : 'left',
    marginBottom: "1.8rem",
    children: [title, href && action ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
      children: isMobile ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Action, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
          action: action,
          href: href,
          title: alt,
          target: target || '_blank'
        }), icon || /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_icons__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})]
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ActionFloat, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
          action: action,
          href: href,
          title: alt,
          target: target || '_blank'
        }), icon || /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_icons__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})]
      })
    }) : null]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SectionTitle);

/***/ }),

/***/ 73119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ getFormattedMonthYear; },
/* harmony export */   "h": function() { return /* binding */ replaceDatePlaceholders; }
/* harmony export */ });
const currentDate = new Date();
const monthYear = currentDate.toLocaleString('it-IT', {
  month: 'long',
  year: 'numeric'
});
const formattedMonth = monthYear.charAt(0).toUpperCase() + monthYear.slice(1, -5);
const formattedYear = currentDate.getFullYear();
const getFormattedMonthYear = () => {
  return {
    formattedMonth,
    formattedYear
  };
};
const replaceDatePlaceholders = text => {
  if (!text) return null; // Fallback se il testo è null o undefined

  return text.replace('{{month}}', formattedMonth).replace('{{year}}', String(formattedYear));
};

/***/ }),

/***/ 28173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useViewItemList; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _events__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99778);
/* harmony import */ var _state__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22988);




/**
 * Emette `view_item_list` quando la lista mostrata cambia davvero.
 *
 * I listing si ri-renderizzano a ogni cambio di filtro o di pagina e l'array
 * `items` è ricostruito ogni volta: la firma sugli id evita di ripetere lo
 * stesso evento a ogni render mantenendo il push su un cambio reale di risultati.
 *
 * L'evento passa da `whenPageReady` perché queste liste arrivano da import
 * dinamici: senza attendere il `page_view` della pagina che le contiene
 * partirebbero con il `page_data` di quella precedente.
 */
function useViewItemList(_ref) {
  let {
    items,
    listId,
    listName,
    enabled = true
  } = _ref;
  const lastSignature = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const queued = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
  const latest = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
    items,
    listId,
    listName
  });
  latest.current = {
    items,
    listId,
    listName
  };
  const signature = `${listId}|${items.map(item => item.item_id).join(',')}`;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!enabled) return;
    if (!items.length) return;
    if (lastSignature.current === signature) return;
    lastSignature.current = signature; // Se i risultati cambiano ancora mentre siamo in coda — i filtri del listing
    // che si assestano prima dell'idratazione — non serve una seconda emissione:
    // al flush si legge comunque la lista aggiornata.

    if (queued.current) return;
    queued.current = true;
    (0,_state__WEBPACK_IMPORTED_MODULE_1__/* .whenPageReady */ .lN)(() => {
      queued.current = false;
      (0,_events__WEBPACK_IMPORTED_MODULE_2__/* .pushViewItemList */ .LM)(latest.current);
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signature, enabled]);
}

/***/ }),

/***/ 29590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "tH": function() { return /* binding */ rentOfferToPageMeta; },
  "ck": function() { return /* binding */ rentOfferToProductItem; },
  "np": function() { return /* binding */ sellOfferToPageMeta; },
  "rW": function() { return /* binding */ sellOfferToProductItem; }
});

// UNUSED EXPORTS: rentOfferToOfferData, rentOfferValue, sellOfferToOfferData, sellOfferValue, toNumber

// EXTERNAL MODULE: ./src/utils/gtm/constants.ts
var constants = __webpack_require__(98845);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./src/utils/gtm/naming.ts
var naming = __webpack_require__(31067);
;// CONCATENATED MODULE: ./src/utils/gtm/brandRules.json
var brandRules_namespaceObject = JSON.parse('{"fiat":{"rpl":22,"offerCustomerType":"B2C","offerType":"Finanziamento"},"jeep":{"rpl":27.5,"offerCustomerType":"B2C","offerType":"Finanziamento"},"bmw":{"offerCustomerType":"B2C","offerType":"Leasing"},"toyota":{"offerCustomerType":"B2B","offerType":"Finanziamento"},"peugeot":{"offerCustomerType":"B2C","offerType":"Finanziamento"}}');
;// CONCATENATED MODULE: ./src/utils/gtm/brandRules.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * Valori commerciali che variano per brand automotive.
 *
 * Oggi vivono in un JSON versionato ([brandRules.json](./brandRules.json)): sono
 * accordi commerciali che cambiano di rado e che il backend non espone. La
 * lettura passa da `getBrandRules`, così che il giorno in cui l'offers-explorer
 * restituirà questi campi basti cambiare questa implementazione senza toccare
 * i punti di chiamata.
 *
 * Un brand non mappato NON eredita un rpl inventato: la chiave viene omessa.
 */



const DEFAULT_RULES = {
  offerCustomerType: 'B2C',
  offerType: constants/* DEFAULT_OFFER_TYPE */.OJ
};
function getBrandRules(brandCode) {
  const key = (0,naming/* slugSegment */.nL)(brandCode);
  const brandRules = key ? brandRules_namespaceObject[key] : undefined;
  return _objectSpread(_objectSpread({}, DEFAULT_RULES), brandRules);
}
;// CONCATENATED MODULE: ./src/utils/gtm/mappers.ts
/**
 * Dai DTO dell'offers-explorer agli oggetti dello schema dataLayer.
 *
 * Attenzione alla semantica dei prezzi, invertita rispetto a quella intuitiva:
 * `ecommerce.items[].price` è il prezzo di LISTINO, mentre `ecommerce.value` è
 * il prezzo promozionale/corrente. GA4 non sottrae mai `discount` da `price`.
 */



/** Converte in numero positivo; qualunque altro caso diventa `undefined` (chiave omessa). */
function toNumber(value) {
  if (value === null || value === undefined || value === '') return undefined;
  const parsed = typeof value === 'number' ? value : parseFloat(`${value}`);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : undefined;
}

const absoluteUrl = path => path ? `${constants/* SITE_ORIGIN */.yp}${path.split('?')[0].split('#')[0]}` : undefined;

const withQuery = path => path ? `${constants/* SITE_ORIGIN */.yp}${path}` : undefined;

const sellOfferPath = offer => {
  var _offer$vehicle, _offer$vehicle2;

  return `/offerte-auto/${((_offer$vehicle = offer.vehicle) === null || _offer$vehicle === void 0 ? void 0 : _offer$vehicle.brandCode) ?? offer.brandCode}/${((_offer$vehicle2 = offer.vehicle) === null || _offer$vehicle2 === void 0 ? void 0 : _offer$vehicle2.modelCode) ?? offer.modelCode}/${offer.code}`;
};

const rentOfferPath = offer => {
  var _offer$vehicle3, _offer$vehicle4;

  return `/noleggio-a-lungo-termine/${((_offer$vehicle3 = offer.vehicle) === null || _offer$vehicle3 === void 0 ? void 0 : _offer$vehicle3.brandCode) ?? offer.brandCode}/${((_offer$vehicle4 = offer.vehicle) === null || _offer$vehicle4 === void 0 ? void 0 : _offer$vehicle4.modelCode) ?? offer.modelCode}/${offer.code}`;
};

function sellOfferToProductItem(offer) {
  var _vehicle$engine;

  let {
    path,
    index
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const detail = offer;
  const {
    vehicle
  } = detail;
  const brand = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.brand) ?? offer.brand;
  const model = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.model) ?? offer.model;
  const version = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.version) ?? offer.version;
  const fuel = vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$engine = vehicle.engine) === null || _vehicle$engine === void 0 ? void 0 : _vehicle$engine.fuel;
  const canonicalPath = path || sellOfferPath(offer);
  return {
    item_id: offer.code,
    item_name: [brand, model, fuel].filter(Boolean).join(' ') || undefined,
    item_brand: brand,
    item_variant: model,
    item_category: fuel,
    item_category2: constants/* VEHICLE_CONDITION */.zN,
    item_category3: vehicle === null || vehicle === void 0 ? void 0 : vehicle.category,
    item_category4: detail.year ? `${detail.year}` : undefined,
    item_category5: version,
    price: toNumber(offer.price),
    currency: constants/* CURRENCY */.wA,
    discount: toNumber(detail.priceReduction),
    image_url: detail.image,
    item_url: withQuery(canonicalPath),
    product_url: absoluteUrl(canonicalPath),
    product_type: constants/* PRODUCT_TYPE */.fY,
    index
  };
}
function rentOfferToProductItem(offer) {
  var _vehicle$engine2, _detail$images, _detail$images$;

  let {
    path,
    index
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const detail = offer;
  const item = offer;
  const {
    vehicle
  } = detail;
  const brand = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.brand) ?? item.brand;
  const model = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.model) ?? item.model;
  const version = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.version) ?? item.version;
  const fuel = vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$engine2 = vehicle.engine) === null || _vehicle$engine2 === void 0 ? void 0 : _vehicle$engine2.fuel;
  const canonicalPath = path || rentOfferPath(offer);
  return {
    item_id: offer.code,
    item_name: [brand, model, fuel].filter(Boolean).join(' ') || undefined,
    item_brand: brand,
    item_variant: model,
    item_category: fuel,
    item_category2: constants/* VEHICLE_CONDITION */.zN,
    item_category3: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.category) ?? item.category,
    item_category5: version,
    // Il noleggio non espone un prezzo di listino del veicolo: resta omesso.
    price: toNumber(detail.specialPrice),
    currency: constants/* CURRENCY */.wA,
    image_url: ((_detail$images = detail.images) === null || _detail$images === void 0 ? void 0 : (_detail$images$ = _detail$images[0]) === null || _detail$images$ === void 0 ? void 0 : _detail$images$.src) ?? item.image,
    item_url: withQuery(canonicalPath),
    product_url: absoluteUrl(canonicalPath),
    product_type: constants/* PRODUCT_TYPE */.fY,
    index
  };
}
function sellOfferToOfferData(offer) {
  var _offer$vehicle5;

  const brandCode = ((_offer$vehicle5 = offer.vehicle) === null || _offer$vehicle5 === void 0 ? void 0 : _offer$vehicle5.brandCode) ?? offer.brandCode;
  const rules = getBrandRules(brandCode);
  return {
    offer_type: rules.offerType,
    offer_customer_type: rules.offerCustomerType,
    offer_acquisition_type: constants/* OFFER_ACQUISITION_TYPE */.Vd,
    monthly_payment: toNumber(offer.monthlyRate)
  };
}
function rentOfferToOfferData(offer) {
  return {
    offer_type: constants/* RENT_OFFER_TYPE */.y,
    offer_customer_type: offer.customerType === 'piva' ? 'B2B' : 'B2C',
    offer_acquisition_type: constants/* OFFER_ACQUISITION_TYPE */.Vd,
    monthly_payment: toNumber(offer.monthlyRate)
  };
}
/** Prezzo promozionale/corrente del veicolo. */

const sellOfferValue = offer => toNumber(offer.specialPrice) ?? toNumber(offer.price);
/** Per il noleggio l'unico valore economico esposto è il canone mensile. */

const rentOfferValue = offer => toNumber(offer.monthlyRate);

/** Meta di pagina per la VDP sell, pronta per `useGtmPage`. */
function sellOfferToPageMeta(offer) {
  var _vehicle$engine3;

  let {
    path,
    pageTitle,
    pageType = 'vdp'
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    vehicle
  } = offer;
  const brandCode = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.brandCode) ?? offer.brandCode;
  return {
    pageType,
    cmsPageId: offer.code,
    pageTitle,
    brand: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.brand) ?? offer.brand,
    model: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.model) ?? offer.model,
    fuel: vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$engine3 = vehicle.engine) === null || _vehicle$engine3 === void 0 ? void 0 : _vehicle$engine3.fuel,
    segment: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.categorySlug) ?? (vehicle === null || vehicle === void 0 ? void 0 : vehicle.category),
    rpl: getBrandRules(brandCode).rpl,
    productItem: sellOfferToProductItem(offer, {
      path
    }),
    offerData: sellOfferToOfferData(offer),
    value: sellOfferValue(offer)
  };
}
/** Meta di pagina per la VDP noleggio, pronta per `useGtmPage`. */

function rentOfferToPageMeta(offer) {
  var _vehicle$engine4;

  let {
    path,
    pageTitle,
    pageType = 'vdp'
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    vehicle
  } = offer;
  return {
    pageType,
    cmsPageId: offer.code,
    pageTitle,
    brand: vehicle === null || vehicle === void 0 ? void 0 : vehicle.brand,
    model: vehicle === null || vehicle === void 0 ? void 0 : vehicle.model,
    fuel: vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$engine4 = vehicle.engine) === null || _vehicle$engine4 === void 0 ? void 0 : _vehicle$engine4.fuel,
    segment: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.categorySlug) ?? (vehicle === null || vehicle === void 0 ? void 0 : vehicle.category),
    rpl: getBrandRules(vehicle === null || vehicle === void 0 ? void 0 : vehicle.brandCode).rpl,
    productItem: rentOfferToProductItem(offer, {
      path
    }),
    offerData: rentOfferToOfferData(offer),
    value: rentOfferValue(offer)
  };
}

/***/ }),

/***/ 55352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jj": function() { return /* binding */ getWindow; },
/* harmony export */   "Me": function() { return /* binding */ getDocument; }
/* harmony export */ });
/* unused harmony exports extend, ssrDocument, ssrWindow */
/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */

/* eslint-disable no-param-reassign */
function isObject(obj) {
  return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
}

function extend() {
  let target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let src = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  Object.keys(src).forEach(key => {
    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
      extend(target[key], src[key]);
    }
  });
}

const ssrDocument = {
  body: {},

  addEventListener() {},

  removeEventListener() {},

  activeElement: {
    blur() {},

    nodeName: ''
  },

  querySelector() {
    return null;
  },

  querySelectorAll() {
    return [];
  },

  getElementById() {
    return null;
  },

  createEvent() {
    return {
      initEvent() {}

    };
  },

  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},

      setAttribute() {},

      getElementsByTagName() {
        return [];
      }

    };
  },

  createElementNS() {
    return {};
  },

  importNode() {
    return null;
  },

  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: ''
  }
};

function getDocument() {
  const doc = typeof document !== 'undefined' ? document : {};
  extend(doc, ssrDocument);
  return doc;
}

const ssrWindow = {
  document: ssrDocument,
  navigator: {
    userAgent: ''
  },
  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: ''
  },
  history: {
    replaceState() {},

    pushState() {},

    go() {},

    back() {}

  },
  CustomEvent: function CustomEvent() {
    return this;
  },

  addEventListener() {},

  removeEventListener() {},

  getComputedStyle() {
    return {
      getPropertyValue() {
        return '';
      }

    };
  },

  Image() {},

  Date() {},

  screen: {},

  setTimeout() {},

  clearTimeout() {},

  matchMedia() {
    return {};
  },

  requestAnimationFrame(callback) {
    if (typeof setTimeout === 'undefined') {
      callback();
      return null;
    }

    return setTimeout(callback, 0);
  },

  cancelAnimationFrame(id) {
    if (typeof setTimeout === 'undefined') {
      return;
    }

    clearTimeout(id);
  }

};

function getWindow() {
  const win =  true ? window : 0;
  extend(win, ssrWindow);
  return win;
}



/***/ }),

/***/ 4730:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ })

}]);